import SectionsData from "modules/shared/profiles/SectionsData";
import React from "react";
import styled from "styled-components";

function ViewPersonalIfon({ data }) {
    return (
        <SectionContainer>
            <SectionsData
                label="Nationality"
                text={data?.nationality}
            />
            <SectionsData
                label="National ID Number "
                text={data?.nationalId}
            />
            <SectionsData
                label="Name(Arabic)"
                text={data?.name}
            />
            <SectionsData
                label="Mobile Number"
                text={data?.phoneNumber}
            />
            <SectionsData
                label="Email"
                text={data?.email}
            />
            {data?.nationality !== "egyptian" && (
                <SectionsData
                    label="Passport Number"
                    text={data?.passportNumber}
                />
            )}
            <SectionsData
                label={
                    data?.nationality === "egyptian"
                        ? "ID Expiration Date"
                        : "Passport Expiration Date"
                }
                text={
                    data?.nationality === "egyptian"
                        ? data?.nationalIdExpiryDate
                        : data?.passportExpiryDate
                }
            />
            <SectionsData
                label="ID Photo - Face"
                image={data?.nationalIdFace}
            />
            <SectionsData
                label="ID Photo - Back"
                image={data?.nationalIdBack}
            />
            {data?.nationality !== "egyptian" && (
                <SectionsData
                    label="Passport Photo"
                    image={data?.passport}
                />
            )}
            <SectionsData
                label="Driver Picture "
                image={data?.photo}
            />
        </SectionContainer>
    );
}
export const SectionContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    flex-wrap: wrap;
`;
export default ViewPersonalIfon;
